import { render, staticRenderFns } from "./manutencao-orcamento.vue?vue&type=template&id=00fd6350&"
import script from "./manutencao-orcamento.vue?vue&type=script&lang=js&"
export * from "./manutencao-orcamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports